<template>
  <div class="modal fade" :id="id" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
    <div class="modal-dialog modal-md" role="document">
      <form class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('absences.detail') }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal">
                <span class="svg-icon svg-icon-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                          fill="currentColor" />
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                          fill="currentColor" />
                  </svg>
                </span>
            </div>
          </div>

          <div class="modal-body">
            <div class="d-flex justify-content-between mb-5">
              <span class="fs-3">{{ $t('absences.demand_user') }}</span>
              <span class="fs-3 fw-bold">{{ absenceDetail.user }}</span>
            </div>
            <div class="d-flex justify-content-between mb-5">
              <span class="fs-3">{{ $t('absences.start_date') }}</span>
              <span class="fs-3 fw-bold">{{ absenceDetail.start_date }}</span>
            </div>
            <div class="d-flex justify-content-between mb-5">
              <span class="fs-3">{{ $t('absences.end_date') }}</span>
              <span class="fs-3 fw-bold">{{ absenceDetail.end_date }}</span>
            </div>
            <div class="bg-light p-5 mb-5 rounded-2">
              <div class="d-flex justify-content-between mb-5">
                <span class="fs-3">{{ $t('absences.type_absence') }}</span>
                <span class="fs-3 fw-bold">{{ absenceDetail.type }}</span>
              </div>
              <div class="d-flex justify-content-between mb-5">
                <span class="fs-3">{{ $t('absences.status') }}</span>
                <span class="badge fs-3" :class="'badge-light-'+absenceDetail.color">{{ absenceDetail.status }}</span>
              </div>
              <div v-if="absenceDetail.approved_owner" class="d-flex justify-content-between mb-5">
                <span class="fs-3">{{ $t('absences.approved_owner') }}</span>
                <span class="fs-3 fw-bold">{{ absenceDetail.approved_owner }}</span>
              </div>
              <div v-if="absenceDetail.validator" class="d-flex justify-content-between mb-5">
                <span class="fs-3">{{ $t('absences.validator') }}</span>
                <span class="fs-3 fw-bold">{{ absenceDetail.validator }}</span>
              </div>
              <div v-if="absenceDetail.rejected_owner" class="d-flex justify-content-between mb-5">
                <span class="fs-3">{{ $t('absences.rejected_owner') }}</span>
                <span class="fs-3 fw-bold">{{ absenceDetail.rejected_owner }}</span>
              </div>
              <div v-if="absenceDetail.motif" class="mb-5">
                <span class="mb-5 fs-3">{{ $t('absences.motif') }}</span>
                <div class="fs-3 fw-bold mt-2" v-html="absenceDetail.motif"></div>
              </div>
              <div v-if="absenceDetail.description" class="mb-5">
                <span class="mb-5 fs-3">{{ $t('absences.description') }}</span>
                <div class="fw-bold fs-3 mt-2" v-html="absenceDetail.description"></div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <Button type="cancel" @click="closeModal" :id="id+'_cancel_btn'" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.close"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>

</template>

<script setup>
import {ref, defineProps} from 'vue'
import Button from "@/components/Button.vue"
import Input from "@/components/Input";

const props = defineProps({
    id: {
      type: String,
      required: true
    },
    form: {
      type: Object,
      default: {}
    },
})

const absenceDetail = ref(props.form)

function closeModal(){
  $('#'+props.id).modal('toggle')
}
</script>